export default "__VITE_ASSET__DmvwXwEQ__"